{
	"title": "Tilgjengelige materialer",
	"showAllTitle": "Vis alt materiell",
	"table": {
		"material": "Materiale",
		"invoicedQuantity": "Fakturert mengde",
		"remainingForTransfer": "Gjenstående for opprettelse av erklæring",
		"fetchError": "Kunne ikke hente materialer",
		"noMaterials": {
			"title": "Ingen materialer tilgjengelig",
			"description": "Du har for øyeblikket ingen materialer tilgjengelig på {{productName}}. Ta kontakt med salgsrepresentanten din for å legge til kontrakten(e) på kontoen din."
		}
	}
}
